import { IFramePostMessageData } from '../types';
import { isValidPostMessageEvent } from './iframe-message-utils';

export type IFrameMessageActionHandler<Type extends IFramePostMessageData['type']> = (
  data: Extract<IFramePostMessageData, { type: Type }>['value']
) => void;

export type IFrameMessageActionHandlers = {
  [K in IFramePostMessageData['type']]?: IFrameMessageActionHandler<K>;
};

export class IFrameMessageHandler {
  private readonly handlers: IFrameMessageActionHandlers = {};

  constructor(
    private readonly origin: string,
    private readonly onMessage: (message: IFramePostMessageData) => void
  ) {}

  handle(event: MessageEvent): void {
    if (!isValidPostMessageEvent(event, this.origin)) return;

    const handler = this.handlers[event.data.type];

    if (!handler) return;

    handler(event.data.value as never);
    this.onMessage(event.data);
  }

  register<Type extends IFramePostMessageData['type']>(
    type: Type,
    handler: IFrameMessageActionHandler<Type>
  ): void {
    this.handlers[type] = handler as never;
  }
}
